import { createAction, props } from '@ngrx/store';

export const getAchievementForm = createAction(
  '[Achievement Component] Get Form Achievement'
);
export const taskCompleted = createAction('[Achievement Component] Get Done');
export const isFormCompleted = createAction(
  '[Achievement Form Component] Set if the form is completed'
);
export const isntFormCompleted = createAction(
  '[Achievement Form Component] Set if the form is not completed'
);
// Deberia ser formIs.. o formIsnt... pero creo que asi se entiende igual
export const isCreating = createAction(
  '[Achievement List Component] Set if the button agregar logro is pressed'
);
export const isntCreating = createAction(
  '[Achievement List Component] Set if the button agregar logro is not pressed'
);

export const saveTitle = createAction(
  '[Achievement Form Component] Save title of achievement',
  props<{ titleForm: string }>()
);
